<template>
  <div>
    <ag-loading v-if="loading" />
    <div class="ag-hashdetail p-4" v-if="hashDetails && !loading">
      <div>
        <h3>
          <ag-truncate
            :text="hashDetails.path"
            :options="{ position: 'middle', first: 24, last: 32 }"
          ></ag-truncate>
        </h3>
        <h6>
          <ag-truncate
            :text="hashDetails.hash"
            :options="{ position: 'middle', first: 24, last: 32 }"
          ></ag-truncate>
        </h6>
      </div>
      <div class="row align-items-center mt-5 mb-5 justify-content-between">
        <div class="d-flex align-items-center">
          <div
            class="ag-progress mr-2"
            style="margin-top: -20px"
            :data-percentage="hashDetails.dedection"
          >
            <span class="progress-left">
              <span class="progress-bar"></span>
            </span>
            <span class="progress-right">
              <span class="progress-bar"></span>
            </span>
          </div>
          <div>
            <h3 class="title mb-0" style="margin-top: -20px">
              {{ hashDetails.dedection }}%
            </h3>
            <p class="info mb-0">{{$t("detection")}}</p>
          </div>
        </div>
        <div class="">
          <p class="title mb-1">Reputation: {{ hashDetails.analysisStats }}</p>
          <p class="info">
            <a class="ag-tooltip" href="#" style="color: #4c8dbb"
              >{{ hashDetails.malicious }}
              <div class="top">
                Selected engines are only trustworthy vendors like Microsoft,
                Symantec/Broadcom, Norton, Trellix/McAfee, mBitDefender,
                F-Secure, MalwareBytes, Sophos, Kaspersky, TrendMicro, ESET,
                Cylance, Sentinel One<i></i></div
            ></a>
          </p>
        </div>
        <div class="">
          <p class="title mb-1">{{ hashDetails.exeSize.split(" ")[1] }}</p>
          <p class="info">
            {{ bytesToSize(hashDetails.exeSize.split(" ")[0]) }}
          </p>
        </div>
        <div class="">
          <p class="title mb-1">{{$t("lastSeen")}}</p>
          <p class="info">
            {{ hashDetails.lastSeen.split("T")[0] }}
            {{ hashDetails.lastSeen.split("T")[1].split(".")[0] }}
          </p>
        </div>
      </div>
      <div class="refresh">
        <div class="row">
          <div class="col-md-8">
            <p>
              {{ t("detectionInfo") }}
              {{ hashDetails.lastSeen.split("T")[0] }}
              {{ hashDetails.lastSeen.split("T")[1].split(".")[0] }}
              <br />
              {{ t("refreshingInfo") }}
            </p>
          </div>
          <div class="col-md-4 d-flex align-items-start">
            <button
              type="button"
              class="ag-button-white mr-4"
              :disabled="checkRefreshDisabled"
              @click="getList()"
            >
              <span class="material-symbols-outlined mr-2">
                refresh
              </span>
              {{ t("refresh") }}
            </button>
            <a
              :href="`https://www.virustotal.com/gui/file/${hashDetails.hash}/detection`"
              target="_blank"
              class="ag-button-white"
            >
                {{ t("viewDetail") }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!hashDetails && !loading" class="no-data-center">
      {{ t("noData") }}
    </div>
  </div>
</template>

<script>
import api from "@/store/axiosAgsc";
import { useStore } from "@/store";
import AgLoading from "@/components/ag-loading/index.vue";
import { useI18n } from "vue-i18n";
import AgTruncate from "@/components/ag-truncate/index.vue";
import moment from "moment";
const store = useStore();
export default {
  name: "ag-hashdetail",
  data: () => ({
    hashDetails: {
      path: "",
      hash: "",
      dedection: 0,
      malicious: "",
      exeSize: "",
      lastSeen: "2021-07-04T06:49:49.347413",
    },
    loading: true,
  }),
  setup() {
    const { t, locale } = useI18n();

    return {
      t,
    };
  },
  components: {
    AgLoading,
    AgTruncate,
  },
  created() {
    this.getList();
  },
  computed: {
    selectedRow() {
      return store.state.general.selectedExpandedRow;
    },
    checkRefreshDisabled() {
      const diffCreation = moment().diff(
        moment(this.hashDetails.creationTime),
        "month"
      );
      if (diffCreation > 12) {
        return true;
      }
      const diffRefresh = moment().diff(
        moment(this.hashDetails.lastSeen),
        "hour"
      );
      if (diffRefresh < 24) {
        return true;
      }
      return false;
    },
  },
  watch: {
    selectedRow() {
      this.getList();
    },
  },
  methods: {
    getList() {
      this.loading = true;
      let hash = null;
      if (
        this.selectedRow &&
        this.selectedRow.hash &&
        this.selectedRow.hash !== "Undefined Hash"
      ) {
        hash = this.selectedRow.hash;
      }

      if (
        this.selectedRow &&
        this.selectedRow.EventDetails &&
        this.selectedRow.EventDetails.Process &&
        this.selectedRow.EventDetails.Process.File &&
        this.selectedRow.EventDetails.Process.File.Hash &&
        this.selectedRow.EventDetails.Process.File.Hash.HashValue
      ) {
        hash = this.selectedRow.EventDetails.Process.File.Hash.HashValue;
      }

      if (hash) {
        api.get("HashInspection/GetHashInfo?hash=" + hash).then((res) => {
          this.hashDetails = res.data.entityData;
          setTimeout(() => {
            this.loading = false;
          }, 350);
        });
      } else {
        this.hashDetails = "";
        setTimeout(() => {
          this.loading = false;
        }, 350);
      }
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-hashdetail {
  padding: 100px !important;
  padding-bottom: 40px !important;
  select {
    color: #4c8dbb;
    border: 1px solid #d8dfe3;
    background: #fff;
    border-radius: 4px;
    padding: 0px 4px;
  }
  h3 {
    color: #5e5e5e;
  }
  h6 {
    font-weight: 300;
  }
  .title {
    color: #5e5e5e;
    font-weight: 700;
    font-size: 18px;
    word-break: break-word;
  }
  .info {
    color: #5e5e5e;
  }
  .refresh {
    margin-top: -30px;
    margin-left: 60px;
    margin-bottom: 40px;

    p {
      color: #fa4443;
    }
  }
}
.ag-progress {
  width: 70px !important;
  height: 70px !important;
  .progress-bar {
    border-color: #d15656;
  }
}
</style>
